// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__GGJiJ","colMin":"styles_colMin__38nrF","colCheckbox":"styles_colCheckbox__3E2J-"};